import axios from 'axios'
import Cookies from 'js-cookie'

let token = Cookies.get('token')

//获取导航菜单
export const findNavTree = params => {return axios.get('/api/menu/findNavTree',{ params: { 'userName' : params} , headers: {'Authorization': 'Bearer ' + token}});};

//更新密码
export const updatePwd = params => {return axios.put('/api/user/updatePwd',params,{headers: {'Authorization': 'Bearer ' + token}})};

//获取角色信息
export const findRoles = params => {return axios.get('/api/role/findRoles',{params: params})};

//密码重置
export const resetPwd = params => {return axios.get('/api/Account/resetPwd',{params: {'accId' : params}})};






// WEBPACK FOOTER //
// ./src/api/api.js